let wakeLock = null;

async function requestWakeLock() {
    try {
        wakeLock = await navigator.wakeLock.request('screen');
        console.log('Wake Lock actief');

        wakeLock.addEventListener('release', () => {
            console.log('Wake Lock vrijgegeven');
        });
    } catch (err) {
        console.error(`${err.name}, ${err.message}`);
    }
}
// Vraag aan bij laden
const $wakelock = document.querySelector('.js-wakelock');
$wakelock.addEventListener('change', (e) => {

    if (e.target.checked) {
        requestWakeLock();
    } else {
        if (wakeLock !== null) {
            wakeLock.release()
                .then(() => {
                    console.log('Wake Lock handmatig vrijgegeven');
                    wakeLock = null;
                })
                .catch((err) => {
                    console.error(`${err.name}, ${err.message}`);
                });
        }
    }
});
